import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]

import { ref, watch, getCurrentInstance } from 'vue'
interface IProps {
  status?: {
    info?: String
    imgSrc?: String
    showRetry?: Boolean
    retryText?: String
  }
  selfStyle?: Object
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    status: { default: () => {
    return {
      info: '',
      imgSrc: '',
      showRetry: false,
      retryText: ''
    }
  } },
    selfStyle: { default: () => {
    return {}
  } }
  },
  emits: ["retry"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const proxy = getCurrentInstance()?.appContext.config.globalProperties
const info = ref<String>(props.status?.info || proxy?.$t('app_empty') || '')
const imgSrc = ref(
  props.status.imgSrc
    ? require('@/assets/images/empty/' + props.status?.imgSrc)
    : require('@/assets/images/empty/empty.png')
)
const showRetry = ref<Boolean>(props.status?.showRetry || false)
const retryText = ref<String>(props.status?.retryText || '重试')
watch(
  () => props.status,
  (newValue) => {
    info.value = newValue.info || proxy?.$t('app_empty') || ''
    imgSrc.value = newValue.imgSrc
      ? require('@/assets/images/empty/' + newValue.imgSrc)
      : require('@/assets/images/empty/empty.png')
    showRetry.value = newValue.showRetry || false
    retryText.value = newValue.retryText || '重试'
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["error_container", imgSrc.value.includes('cont') ? 'error_cont' : '']),
    style: _normalizeStyle({ ...__props.selfStyle })
  }, [
    _createElementVNode("img", {
      src: imgSrc.value,
      alt: "",
      class: _normalizeClass(["img", imgSrc.value.includes('cont') ? 'img_cont' : ''])
    }, null, 10, _hoisted_1),
    _createElementVNode("span", null, _toDisplayString(info.value), 1),
    (showRetry.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "retry_btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
        }, _toDisplayString(retryText.value), 1))
      : _createCommentVNode("", true)
  ], 6))
}
}

})